
import { Box } from "reflexbox";
import styled from "styled-components";

const Space = styled(Box)`
  padding: 0 4px;
`;

export default Space;